import React, { CSSProperties } from 'react';
import { SvgIcon, styled } from '@mui/material';
import * as Icons from '../assets/icons';
import { DesignTokens } from '../specify';

export const GivelifyIconVariants = [
    'bank',
    'bars',
    'calendar',
    'campuses',
    'check',
    'bank-reports',
    'computer',
    'insititution-new-checkmark',
    'breadcrumbs-completed',
    'mail',
    'donor',
    'heart-in-hand',
    'donor-recognition',
    'people',
    'info-filled',
    'redo',
    'rotate-right',
    'circle',
    'close',
    'close-outlined',
    'donations',
    'donors',
    'down-arrow',
    'down-arrow-circle',
    'down-chevron',
    'ellipsis',
    'envelopes',
    'file',
    'file-alt',
    'help',
    'info',
    'integrations',
    'left-arrow',
    'left-chevron',
    'play-animation',
    'lock',
    'loading',
    'location-map',
    'download',
    'more',
    'more-no-circle',
    'overview',
    'password-hidden',
    'password-visible',
    'quick-give',
    'regenerate',
    'arrange',
    'move',
    'loading',
    'checkmarkSuccess',
    'giving-money',
    'inactive-envelope',
    'switch-arrow',
    'active-envelope',
    'close-circle',
    'reminder',
    'reports',
    'events',
    'right-arrow',
    'right-chevron',
    'select',
    'settings',
    'trash',
    'up-arrow',
    'up-chevron',
    'left-chevron-double',
    'right-chevron-double',
    'bank-deposits',
    'by-donor-fill',
    'by-envelope-fill',
    'data-exports',
    'donors-old',
    'hand-holding-usd-fill',
    'import-friendly',
    'quickbooks',
    'poll',
    'report-colored',
    'file-export',
    'tax-id',
    'reminder-colored',
    'error-warning-colored',
    'success-colored',
    'bank-colored',
    'primary-rep-colored',
    'institution',
    'back',
    'organization',
    'facebook',
    'twitter',
    'warning',
    'verifyIcon',
    'success-box-icon',
    'info-box-icon',
    'info-circle',
    'location-pin',
    'error-box-icon',
    'warning-box-icon',
    'shieldIcon',
    'upload',
    'alert',
    'info-warning',
    'lock-check',
    'summary',
    'envelope',
    'users',
    'avatar',
    'image',
    'lock-old',
    'success',
    'givelify',
    'earthGlobe',
    'phone',
    'play',
    'edit',
    'email',
    'phone-new',
    'location',
    'square-usa',
    'square-bahamas',
    'square-no-flag',
    'send',
    'confetti-left',
    'confetti-right',
    'generosity',
    'dot',
    'gift-card',
    'star',
    'thumb-up',
    'alert2',
    'giving-app',
    'organization-round',
    'previous-page',
    'next-page',
    'seeds',
    'seeds-white',
    'donor-recognition-notification',
    'growth',
    'warning-triangle',
    'gift',
    'seeds-outline',
    'big-info-error',
    'plus',
    'minus',
    'donors-round',
    'infoV2',
    'give',
    'camera',
    'checkmark-rounded',
] as const;

export type GivelifyIconVariant = (typeof GivelifyIconVariants)[number];

const getIconSvg: Record<GivelifyIconVariant, React.ComponentType> = {
    bank: Icons.SvgBank,
    'bank-reports': Icons.SvgBankReports,
    'bank-colored': Icons.SvgBankColored,
    'bank-deposits': Icons.SvgBankDeposits,
    bars: Icons.SvgBars,
    'by-donor-fill': Icons.SvgByDonorFill,
    'by-envelope-fill': Icons.SvgByEnvelopeFill,
    calendar: Icons.SvgCalendar,
    campuses: Icons.SvgCampuses,
    check: Icons.SvgCheck,
    circle: Icons.SvgCircle,
    close: Icons.SvgClose,
    computer: Icons.SvgComputer,
    'insititution-new-checkmark': Icons.SvgInstitutionNewCheckmark,
    'breadcrumbs-completed': Icons.SvgBreadcrumbsCompleted,
    mail: Icons.SvgMail,
    donor: Icons.SvgDonor,
    'play-animation': Icons.SvgPlayAnimation,
    'heart-in-hand': Icons.SvgHeartInHand,
    'donor-recognition': Icons.SvgDonorRecognition,
    people: Icons.SvgPeople,
    'info-filled': Icons.SvgInfoFilled,
    institution: Icons.SvgInstitution,
    back: Icons.SvgBack,
    redo: Icons.SvgRedo,
    'rotate-right': Icons.SvgRotateRight,
    'close-outlined': Icons.SvgCloseOutlined,
    'data-exports': Icons.SvgDataExports,
    donations: Icons.SvgDonations,
    donors: Icons.SvgDonors,
    'donors-old': Icons.SvgDonorsOld,
    'down-arrow': Icons.SvgDownArrow,
    'down-arrow-circle': Icons.SvgDownArrowCircle,
    'down-chevron': Icons.SvgDownChevron,
    ellipsis: Icons.SvgEllipsis,
    envelopes: Icons.SvgEnvelopes,
    'error-warning-colored': Icons.SvgErrorWarningColored,
    file: Icons.SvgFile,
    'file-alt': Icons.SvgFileAlt,
    'file-export': Icons.SvgFileExport,
    'hand-holding-usd-fill': Icons.SvgHandHoldingUsdFill,
    help: Icons.SvgHelp,
    'import-friendly': Icons.SvgImportFriendly,
    info: Icons.SvgInfo,
    integrations: Icons.SvgIntegrations,
    'left-arrow': Icons.SvgLeftArrow,
    'left-chevron': Icons.SvgLeftChevronBig,
    'left-chevron-double': Icons.SvgLeftChevronDouble,
    lock: Icons.SvgLock,
    loading: Icons.SvgLoading,
    download: Icons.SvgDownload,
    more: Icons.SvgMore,
    'more-no-circle': Icons.SvgMoreNoCircle,
    'location-map': Icons.SvgLocationMap,
    organization: Icons.SvgOrganization,
    overview: Icons.SvgOverview,
    'password-hidden': Icons.SvgPasswordHidden,
    'password-visible': Icons.SvgPasswordVisible,
    poll: Icons.SvgPoll,
    'primary-rep-colored': Icons.SvgPrimaryRepColored,
    'quick-give': Icons.SvgQuickGive,
    quickbooks: Icons.SvgQuickbooks,
    regenerate: Icons.SvgRegenerate,
    arrange: Icons.SvgArrange,
    move: Icons.SvgMove,
    checkmarkSuccess: Icons.SvgCheckmarkSuccess,
    'giving-money': Icons.SvgGivingMoney,
    'inactive-envelope': Icons.SvgInactiveEnvelope,
    'switch-arrow': Icons.SvgSwitchArrow,
    'active-envelope': Icons.SvgActiveEnvelope,
    'close-circle': Icons.SvgCloseCircle,
    reminder: Icons.SvgReminder,
    'reminder-colored': Icons.SvgReminderColored,
    'report-colored': Icons.SvgReportColored,
    reports: Icons.SvgReports,
    events: Icons.SvgEvents,
    'right-arrow': Icons.SvgRightArrow,
    'right-chevron': Icons.SvgRightChevronBig,
    'right-chevron-double': Icons.SvgRightChevronDouble,
    select: Icons.SvgSelect,
    settings: Icons.SvgSettings,
    'success-colored': Icons.SvgSuccessColored,
    'tax-id': Icons.SvgTaxId,
    trash: Icons.SvgTrash,
    'up-arrow': Icons.SvgUpArrow,
    'up-chevron': Icons.SvgUpChevron,
    facebook: Icons.SvgFacebook,
    twitter: Icons.SvgTwitter,
    warning: Icons.SvgWarning,
    verifyIcon: Icons.SvgVerify,
    shieldIcon: Icons.ShieldIcon,
    'success-box-icon': Icons.SvgSuccessBoxIcon,
    'info-box-icon': Icons.SvgInfoBoxIcon,
    'info-circle': Icons.SvgInfoCircle,
    'location-pin': Icons.SvgLocationPin,
    'error-box-icon': Icons.SvgErrorBoxIcon,
    'warning-box-icon': Icons.SvgWarningBoxIcon,
    upload: Icons.UploadIcon,
    alert: Icons.AlertIcon,
    'info-warning': Icons.InfoWarningIcon,
    'lock-check': Icons.LockCheckIcon,
    summary: Icons.SvgGivingSummary,
    envelope: Icons.EnvelopeIcon,
    users: Icons.UsersIcon,
    avatar: Icons.SvgAvatar,
    image: Icons.SvgImage,
    'lock-old': Icons.SvgLockOld,
    success: Icons.SvgSuccessIcon,
    givelify: Icons.SvgGivelifyLogoIcon,
    earthGlobe: Icons.SvgEarthGlobeIcon,
    phone: Icons.SvgPhoneIcon,
    play: Icons.SvgPlayIcon,
    edit: Icons.SvgEdit,
    email: Icons.SvgEmail,
    'phone-new': Icons.SvgPhoneNew,
    location: Icons.SvgLocation,
    'square-usa': Icons.SvgSquareUSA,
    'square-bahamas': Icons.SvgSquareBahamas,
    'square-no-flag': Icons.SvgSquareNoFlag,
    send: Icons.SvgSend,
    'confetti-left': Icons.ConfettiLeft,
    'confetti-right': Icons.ConfettiRight,
    generosity: Icons.Generosity,
    dot: Icons.SvgDot,
    'gift-card': Icons.GiftCardIcon,
    star: Icons.StarIcon,
    'thumb-up': Icons.ThumbUpIcon,
    alert2: Icons.Alert2Icon,
    'giving-app': Icons.GivelifyGivingAppIcon,
    'organization-round': Icons.OrganizationRoundIcon,
    'previous-page': Icons.PreviousPageIcon,
    'next-page': Icons.NextPageIcon,
    seeds: Icons.SvgSeeds,
    'seeds-white': Icons.SeedsWhiteIcon,
    'donor-recognition-notification': Icons.DonorRecognitionNotificationIcon,
    growth: Icons.SvgGrowth,
    'warning-triangle': Icons.WarningTriangle,
    gift: Icons.SvgGift,
    'seeds-outline': Icons.SvgSeedsOutline,
    'big-info-error': Icons.BigInfoErrorIcon,
    plus: Icons.PlusIcon,
    minus: Icons.MinusIcon,
    'donors-round': Icons.SvgDonorsRound,
    infoV2: Icons.SvgInfoV2,
    give: Icons.SvgGiveIcon,
    camera: Icons.SvgCamera,
    'checkmark-rounded': Icons.SvgCheckmarkRounded,
};

type StyleIconProp = {
    fontSize?: 'inherit' | number;
    color?: 'inherit' | string;
    spin?: boolean;
};

const StyleIcon = styled('span', {
    shouldForwardProp: (prop) =>
        prop !== 'spin' && prop !== 'color' && prop !== 'fontSize',
})<StyleIconProp>((props) => ({
    fontSize: props.fontSize
        ? props.fontSize === 'inherit'
            ? 'inherit'
            : `${props.fontSize}px`
        : DesignTokens.measurement.iconDefaultSize,
    lineHeight: props.fontSize
        ? props.fontSize === 'inherit'
            ? 'inherit'
            : `${props.fontSize}px`
        : DesignTokens.measurement.iconDefaultSize,
    color: props.color ? props.color : DesignTokens.color.iconPrimary,
    display: 'inline-flex',
    animation: props.spin ? `spinner 2s linear infinite` : 'none',
    '@keyframes spinner': {
        '0%': {
            transform: 'rotate(0deg)',
        },
        '100%': {
            transform: 'rotate(360deg)',
        },
    },
}));

export type GivelifyIconProps = {
    id?: string;
    variant: GivelifyIconVariant;
    fontSize?: 'inherit' | number;
    color?: 'inherit' | string;
    className?: string;
    ['data-testid']?: string;
    spin?: boolean;
    style?: CSSProperties;
};

export const GivelifyIcon = ({
    id,
    variant,
    fontSize = 'inherit',
    color = 'inherit',
    className,
    'data-testid': dataTestId,
    spin,
    style,
}: GivelifyIconProps) => {
    const iconComponent = React.useMemo(() => {
        return getIconSvg[variant];
    }, [variant]);
    return (
        <StyleIcon
            className={className}
            color={color}
            data-testid={dataTestId}
            fontSize={fontSize}
            id={id}
            spin={spin}
            style={style}
        >
            <SvgIcon component={iconComponent} />
        </StyleIcon>
    );
};
